import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'bw-topbar-legacy',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.scss'],
    standalone: false
})
export class TopbarComponentLegacy  {
  @Output() logo = new EventEmitter();
  constructor() {}


  logoClick() {
    this.logo.emit();
  }
}
